var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',[_vm._v("Server is up and running")])
}
var staticRenderFns = []

export { render, staticRenderFns }